<span [tooltip]="sinpermisos">
  <ng-container #vc></ng-container>
  <ng-template #sinpermisos>
    <p>{{warning}}</p>
  </ng-template>
</span>
